<template>
  <BaseView class="index-container">
    <div slot="contantView" class="content">
      <div class="index-panel">
        <div class="nav-panel">
          <HeaderView :active-index="6"/>
          <img src="../assets/spsc/contactUsBg.png" class="navImg"/>
        </div>
        <section class="nav-section">
          <div class="nav-info">
            <div class="nav-main-text" @click="goGoalPage('/')">Home</div>
            <div class="nav-arrow">></div>
            <div class="nav-sub-text" @click="goGoalPage('/contactUs')">Contact us</div>
          </div>
          <div class="nav-line"></div>
        </section>
        <section class="content-panel">
          <div class="contactus-group">
            <div class="main-text">Job Fraud Alert – Please Read</div>
            <div class="content-line"></div>
            <div class="intro-text">
              <span>SPSC has received reports about individuals receiving fraudulent job confirmations and requests for interviews, offers, or solicitations for training via letters, emails, social</span>
              <span> postings, phone calls, instant messages (including WeChat, WhatsApp) and texts.  </span>
            </div>
            <div class="intro-text">
              <span>The fraudulent offers typically include the SPSC logo, the name of an actual SPSC executive, and a phone number. Potential applicants are encouraged to call in pursuit</span>
              <span> of job opportunities. Communications and other materials often solicit personal information or money. </span>
            </div>
            <div class="intro-text">
              <span>If you receive unsolicited job or interview offers or are unsure if the offer you received is fraudulent, contact SPSC at info@sinopacificsupplychain.com.  Please forward the email, </span>
              <span>phone number, and any other documentation you received.</span>
            </div>
          </div>
          <div class="contactus-group">
            <div class="main-text">For your protection, Please do not</div>
            <div class="content-line"></div>
            <div class="protection-text">
              <div>Respond to unsolicited business propositions and/or offers of employment from people with whom you are unfamiliar.</div>
              <div>Disclose your personal or financial details to anyone you do not know.</div>
              <div>Send any money in association with a job application.</div>
              <div>Engage in further communication with a suspicious sender.</div>
            </div>
          </div>
          <div class="contactus-group">
            <div class="main-text">Contact us</div>
            <div class="content-line"></div>
            <div class="contact-text">
              <div>If you want</div>
              <div>* Apply for a job/check CV status</div>
              <div>* Become a SPSC supplier</div>
              <div>* Become a SPSC contractor</div>
              <div>And any other suggestion and quotation please connect us: <a href="mailto:wordpress@example.com" class="email-text"> info@sinopacificsupplychain.com</a></div>
            </div>
          </div>
        </section>
        <FooterView />
      </div>
    </div>
  </BaseView>
</template>

<script>
import BaseView from '@/components/BaseView.vue'
import HeaderView from '@/components/HeaderView.vue'
import FooterView from '@/components/FooterView.vue'

export default {
  name: '',
  props: {

  },
  components: {
    BaseView,
    HeaderView,
    FooterView
  },
  data () {
    return {

    }
  },
  methods: {
    goGoalPage( pathName) {
      this.$router.replace({ path: pathName})
    }
  },
  created () {
  }
}
</script>
<style scoped lang="scss">

.index-container {
  background: #FFFFFF;
  width: 100%;
}
.index-panel {
  width: 100%;
  min-width: 1200px;
} 

.nav-panel {
  width: 100%;
  height: 100%;
}

.navImg {
  width: 100%;
  height: auto;
  margin-top: -80px;
}

.nav-section {
  width: 1200px;
  margin: 40px auto 60px auto;
}

.nav-info {
  display: flex;
  justify-content: flex-start;
  justify-items: center;
}

.nav-main-text, .nav-sub-text {
  font-size: 14px;
  color: #333333;
  cursor: pointer;
}

.nav-arrow {
  margin: 0 10px;
}

.nav-line {
  width: 100%;
  height: 1px;
  background: #D8D8D8;
  margin-top: 16px;
}

.content-panel {
  width: 1200px;
  margin: 0 auto 80px auto;
}

.contactus-group {
  margin-bottom: 90px;
}

.main-text {
  font-size: 32px;
  font-weight: bold;
  color: #111111;
}

.content-line {
  width: 100%;
  height: 4px;
  background: #0281C1;
  margin: 20px auto 40px auto;
}

.intro-text {
  font-size: 16px;
  color: #333333;
  line-height: 28px;
  margin-bottom: 20px;
}

.protection-text {
  font-size: 16px;
  color: #333333;
  line-height: 28px;
  margin-bottom: 20px;
}

.protection-text div {
  display: block;
  margin-bottom: 20px;
}

.contact-text {
  font-size: 16px;
  color: #333333;
  line-height: 28px;
  margin-bottom: 20px;
}

.contact-text div {
  display: block;
  margin-bottom: 20px;
}
.email-text {
  font-size: 16px;
  color: #333333;
  font-weight: 600;
}

</style>